import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { isTokenExpired } from "./utils/auth";

// Check token at startup
const token = localStorage.getItem('_token');
if (token && isTokenExpired(token)) {
  console.warn('Token expired, logging out...');
  localStorage.removeItem('_token');
  if (window.location.pathname !== '/auth/login') {
    window.location.href = '/auth/login';
  }
}

// PrimeVue UI
import PrimeVue from "primevue/config";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

// Custom Style
import "./assets/css/custom.css";

// PrimeVue Preset
import MyPreset from "./assets/js/createPreset.js";

// Axios config
import axios from "axios";
// axios.defaults.baseURL = "http://10.90.60.130:8000/";
axios.defaults.baseURL = "https://sizing-tool.scsops.dev/";
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('_token');
      if (router.currentRoute.value.path !== '/auth/login') {
        router.push('/auth/login');
      }
    }
    return Promise.reject(error);
  }
);



// ✅ PrimeVue Toast
import ToastService from "primevue/toastservice";
import Toast from "primevue/toast";

// ✅ PrimeVue ConfirmDialog
import ConfirmationService from "primevue/confirmationservice";
import ConfirmDialog from "primevue/confirmdialog";

// Create app
const app = createApp(App);

// Register plugins and components
app.use(store);
app.use(router);
app.use(PrimeVue, {
  ripple: true,
  theme: {
    preset: MyPreset,
    options: {
      darkModeSelector: false || "none",
    },
  },
});

app.use(ToastService, {
  defaultOptions: {
    life: 3000,
  },
});
app.use(ConfirmationService); // ✅ Register Confirm service

app.component("Toast", Toast); // ✅ Global <Toast />
app.component("ConfirmDialog", ConfirmDialog); // ✅ Global <ConfirmDialog />

// Mount the app
app.mount("#app");
